module.exports = __webpack_public_path__ + "img/nav5h.b04d7950.png";